export default "__VITE_ASSET__CGixNPy8__"